import type { Locale } from 'date-fns';
import { de, enUS, fr, it, ja } from 'date-fns/locale';

import { useSPIntl } from './useIntl';

export function useLocale() {
  const { locale } = useSPIntl();
  return [getLocale(locale)];
}

function getLocale(locale: string): Locale {
  switch (locale) {
    case 'ja':
      return ja;
    case 'fr':
      return fr;
    case 'de':
      return de;
    case 'it':
      return it;
    default:
      return enUS;
  }
}
